<script setup>
import VueApexCharts from "vue3-apexcharts";

const props = defineProps({
  series: Array,
  labels: Array,
  totalLabel: String
})
const chart = {
  series: props.series,
  colors: ["#1C64F2", "#16BDCA"],
  chart: {
    type: "donut",
  },
  stroke: {
    colors: ["transparent"],
    lineCap: "",
  },
  plotOptions: {
    pie: {
      donut: {
        labels: {
          show: true,
          name: {
            show: true,
            fontFamily: "Inter, sans-serif",
            offsetY: 20,
          },
          total: {
            showAlways: true,
            show: true,
            fontSize: '1rem',
            label: props.totalLabel,
          },
          value: {
            show: true,
            fontSize: '1.125rem',
            fontWeight: 'bold',
            offsetY: -20,
          },
        },
        size: "70%",
      },
    },
  },
  grid: {
    padding: {
      top: -2,
    },
  },
  labels: props.labels,
  dataLabels: {
    enabled: false,
  },
  legend: {
    position: "bottom",
  },
}
</script>

<template>
  <VueApexCharts :options="chart" :series="chart.series"></VueApexCharts>
</template>
